export default function Hero() {
  const strengths = [
    { icon: "ri-timer-flash-line", text: "最短即日対応" },
    { icon: "ri-money-cny-circle-line", text: "見積無料" },
    { icon: "ri-check-double-line", text: "追加料金なし" },
    { icon: "ri-map-pin-line", text: "京都府全域対応" },
  ];

  const trustItems = [
    { icon: "ri-timer-flash-line", text: "最短即日対応", sub: "急なご依頼にも迅速対応" },
    { icon: "ri-shield-check-line", text: "許可業者", sub: "産業廃棄物収集運搬業の許可を取得" },
    { icon: "ri-file-list-3-line", text: "追加料金なしの明朗会計", sub: "お見積り後の追加料金は一切ありません" },
    { icon: "ri-building-2-line", text: "法人・不動産会社対応", sub: "法人様・不動産会社様からのご依頼も多数対応" },
  ];

  return (
    <>
      <section id="top" className="relative w-full min-h-[600px] md:min-h-[680px] lg:min-h-[720px] flex flex-col">
        {/* Background image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Two%20Japanese%20male%20workers%20in%20their%20late%2020s%20to%20early%2040s%20wearing%20clean%20navy%20blue%20work%20uniforms%20with%20company%20logo%20patch%20smiling%20sincerely%20while%20lifting%20a%20large%20cardboard%20box%20together%20beside%20a%20white%20light%20commercial%20truck%20with%20open%20cargo%20door%20in%20a%20narrow%20quiet%20Kyoto%20residential%20alley%20bordered%20by%20traditional%20dark%20wooden%20machiya%20townhouses%20with%20tiled%20roofs%20lush%20green%20potted%20plants%20and%20stone%20walls%20warm%20natural%20afternoon%20sunlight%20streaming%20through%20the%20street%20creating%20soft%20shadows%20documentary%20style%20candid%20workplace%20photography%20shot%20on%20professional%20DSLR%20camera%20with%20shallow%20depth%20of%20field%20subjects%20occupy%20right%20portion%20of%20frame%20leaving%20spacious%20clean%20background%20on%20left%20side%20highly%20photorealistic%20genuine%20unposed%20expression%20no%20artificial%20studio%20lighting%20no%20AI%20illustration%20look%20authentic%20Japanese%20waste%20collection%20service%20crew%20portrait&width=1600&height=900&seq=ats-hero-v19-2001&orientation=landscape"
            alt="京都の住宅街で不用品回収作業を行う京都ゴミ処分センターの男性スタッフ2名と清潔な作業車両"
            fetchPriority="high"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Overlay — white semi-transparent for readability */}
        <div className="absolute inset-0 z-[1] bg-white/80 md:bg-white/75"></div>

        {/* Content layer */}
        <div className="relative z-10 flex flex-col flex-1 pt-20 md:pt-24">
          <div className="flex-1 flex items-center">
            <div className="w-full max-w-6xl mx-auto px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16 py-10 md:py-14">
              <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12 xl:gap-16">

                {/* ===== Left: text content ===== */}
                <div className="flex-1 max-w-xl lg:max-w-lg">
                  {/* Catch copy */}
                  <p className="font-mincho text-accent-800 text-lg md:text-xl tracking-[0.15em] mb-4 md:mb-5">
                    京都の暮らしを、そっと片づける。
                  </p>

                  {/* Main heading */}
                  <h1 className="font-heading font-bold text-2xl sm:text-3xl md:text-[32px] lg:text-[36px] text-foreground-950 leading-[1.5] tracking-wide">
                    京都の不用品回収・
                    <br />
                    遺品整理なら
                    <br />
                    <span className="text-primary-600">京都ゴミ処分センター</span>
                  </h1>

                  {/* Sub copy */}
                  <p className="mt-4 md:mt-5 text-sm md:text-[15px] text-foreground-700 leading-[1.9]">
                    京都府全域対応。不用品回収・遺品整理・ゴミ屋敷清掃・残置物撤去・
                    産業廃棄物収集運搬まで幅広く対応しています。
                    <br className="hidden md:block" />
                    ご家庭のお片付けから法人・不動産会社様まで、一件一件丁寧に対応いたします。
                  </p>

                  {/* CTA buttons */}
                  <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3">
                    <a
                      href="tel:0120024747"
                      className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors shadow-none"
                    >
                      <i className="ri-phone-fill text-lg md:text-xl"></i>
                      電話で無料相談
                    </a>
                    <a
                      href="https://lin.ee/xf3zQex"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm md:text-base whitespace-nowrap cursor-pointer transition-colors shadow-none"
                    >
                      <i className="ri-line-fill text-lg md:text-xl"></i>
                      LINEで写真見積り
                    </a>
                  </div>
                </div>

                {/* ===== Right: pricing card + strengths ===== */}
                <div className="lg:w-[400px] xl:w-[440px] shrink-0 w-full flex flex-col gap-5 lg:self-center">
                  {/* Pricing card — glass effect */}
                  <div className="bg-white/85 backdrop-blur-sm border border-primary-200/50 rounded-2xl p-6 md:p-8 shadow-sm relative overflow-hidden">
                    {/* Top accent bar */}
                    <div className="absolute top-0 left-0 right-0 h-1.5 bg-accent-500"></div>

                    {/* Badge */}
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs md:text-sm font-bold tracking-widest mb-4 whitespace-nowrap">
                      <i className="ri-sparkling-2-line text-sm"></i>
                      人気No.1プラン
                    </span>

                    {/* Plan name */}
                    <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-3">
                      かご台車1台
                    </h3>

                    {/* Price — largest element */}
                    <div className="flex items-baseline gap-x-2 gap-y-1 mb-4">
                      <span className="font-heading font-bold text-5xl md:text-6xl text-primary-600 leading-none tracking-tight">
                        9,000
                      </span>
                      <span className="font-heading font-bold text-2xl md:text-3xl text-primary-600 leading-none">
                        円〜
                      </span>
                      <span className="text-xs text-foreground-500 ml-1">（税込）</span>
                    </div>

                    {/* Description */}
                    <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed mb-5">
                      少量の不用品回収におすすめのプランです。家庭から出る不用品・ゴミを、かご台車1台分を目安に回収いたします。
                    </p>

                    {/* Feature items */}
                    <ul className="space-y-2.5 mb-4">
                      <li className="flex items-start gap-2 text-sm md:text-[15px] text-foreground-700">
                        <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                          <i className="ri-check-line"></i>
                        </span>
                        <span>45Lゴミ袋 約25〜30袋</span>
                      </li>
                      <li className="flex items-start gap-2 text-sm md:text-[15px] text-foreground-700">
                        <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                          <i className="ri-check-line"></i>
                        </span>
                        <span>ダンボール 約15箱程度</span>
                      </li>
                      <li className="flex items-start gap-2 text-sm md:text-[15px] text-foreground-700">
                        <span className="w-5 h-5 mt-0.5 flex items-center justify-center text-primary-600 shrink-0">
                          <i className="ri-check-line"></i>
                        </span>
                        <span>小型家具・衣類・生活用品も回収可能</span>
                      </li>
                    </ul>

                    {/* Note */}
                    <p className="text-xs text-foreground-500 leading-relaxed mb-5">
                      ※回収品目・重量・搬出状況・作業内容により料金が変動する場合があります。
                    </p>

                    {/* Infographic image */}
                    <div className="rounded-xl overflow-hidden bg-white border border-background-200">
                      <img
                        src="https://static.readdy.ai/image/9751c2861f77ccab088a483472b903b8/6d7a5137bf1e5be6f4f244a6622b3b20.png"
                        alt="かご台車1台 9,000円〜の料金案内インフォグラフィック。ゴミの量でわかりやすい安心料金。かご台車1台（幅約110cm×奥行約80cm×高さ約170cm、積載量約1.2㎡・400kgまで）で9,000円〜（税込）。可燃ゴミ袋約30〜40袋、段ボール約10〜20枚、木くず・小型家具、ペットボトル・缶多数、その他不用品いろいろが積み込めます。"
                        className="w-full h-auto object-contain"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  {/* Strengths */}
                  <div className="grid grid-cols-2 gap-3">
                    {strengths.map((s) => (
                      <div key={s.text} className="flex items-center gap-2">
                        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 shrink-0">
                          <i className={`${s.icon} text-primary-600 text-sm`}></i>
                        </div>
                        <span className="text-xs font-bold text-foreground-800 whitespace-nowrap">{s.text}</span>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>
          </div>

          {/* Company info card — overlapping bottom of hero */}
          <div className="w-full max-w-6xl mx-auto px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16 pb-6 md:pb-8">
            <div className="bg-background-50/95 backdrop-blur-sm border border-primary-200 rounded-lg p-5 md:p-6">
              <div className="flex flex-col lg:flex-row lg:items-center gap-5 md:gap-6">
                {/* Phone — most prominent */}
                <a
                  href="tel:0120024747"
                  className="flex items-center gap-3 text-primary-800 hover:text-primary-700 transition-colors cursor-pointer shrink-0"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                    <i className="ri-phone-fill text-primary-600 text-xl"></i>
                  </div>
                  <div>
                    <p className="text-xs text-primary-700 font-medium tracking-wide">お電話でのお問い合わせ</p>
                    <p className="font-heading font-bold text-2xl md:text-[28px] text-primary-800 tracking-wide">0120-02-4747</p>
                  </div>
                </a>

                {/* Divider */}
                <div className="hidden lg:block w-px h-12 bg-primary-200 shrink-0"></div>

                {/* Info items row */}
                <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-3">
                  <div className="flex items-start gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-primary-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">所在地</p>
                      <p className="text-xs text-foreground-700 leading-snug">〒612-8449</p>
                      <p className="text-xs text-foreground-700 leading-snug">京都府京都市伏見区竹田西小屋ノ内町13</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                      <i className="ri-time-line text-primary-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">営業時間</p>
                      <p className="text-xs text-foreground-700 leading-snug">9:00〜17:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                      <i className="ri-calendar-check-line text-primary-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">定休日</p>
                      <p className="text-xs text-foreground-700 leading-snug">年中無休</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 shrink-0 mt-0.5">
                      <i className="ri-focus-3-line text-primary-600 text-sm"></i>
                    </div>
                    <div>
                      <p className="text-[11px] text-primary-700 font-medium leading-none mb-0.5">対応エリア</p>
                      <p className="text-xs text-foreground-700 leading-snug">京都市</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust bar — below hero */}
      <div className="border-t border-b border-background-200 bg-background-50">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 md:px-10 lg:px-12 xl:px-16 py-6 md:py-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {trustItems.map((item) => (
              <div key={item.text} className="flex items-start gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <i className={`${item.icon} text-primary-600 text-base md:text-lg`}></i>
                </div>
                <div>
                  <p className="text-sm md:text-[15px] font-bold text-foreground-800 leading-snug">{item.text}</p>
                  <p className="text-xs text-foreground-500 leading-snug mt-0.5">{item.sub}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}